import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sonatype = defineConnector({
  identifier: "sonatype",
  name: "Sonatype",
  tagLine: "Repository and supply chain automation",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ url }) =>
    url ? `${url}/.*` : "https://sonatype.example.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Create credentials in Sonatype",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://help.sonatype.com/en/automation.html](https://help.sonatype.com/en/automation.html) to create credentials with the permissions you want 3B to use.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "url",
          label: "Sonatype base URL",
          placeholder: "https://sonatype.example.com",
          required: true,
          target: { kind: "configuration", field: "url" },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: {
            kind: "secrets",
            field: "username",
          },
        },
        {
          kind: "input",
          label: "Password or user token",
          required: true,
          target: {
            kind: "secrets",
            field: "password",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://sonatype.example.com/health",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod, ...configuration }) => ({
      url:
        testUrl ??
        (({ url }) => `${url}/service/rest/v1/status`)(configuration),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
